import React, { useState, useEffect } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form} from 'react-bootstrap';
import * as Icon from 'react-feather';
import { mexicoCityToday } from '../../../../utils/dateTime';

function DefaultModal(props) {
    const authHeader = useAuthHeader();

        const today = mexicoCityToday();
        const apiUrl = process.env.REACT_APP_URL;
        const dateTimeString = props.data.date_loaded || "";
        const [datePart, timePart] = dateTimeString.split(' ');
        const [units, setUnits] = useState([]);
        useEffect(() => {
            if (props.show) {
            axios({
                method: 'GET',
                url: apiUrl + '/units/get_all_units',
                headers: {
                Authorization: authHeader()
            },
            }).then(response => {
                setUnits(response.data.msg.Units);
            }).catch(error => {
                alert(error);
            });
            }
        }, [props.show]);

        const handleButtonClick = (event) => {
            // alert('Botón de Guardar presionado');
            event.preventDefault();
            const data = {
                'id': props.data.id,
                'date_loaded': event.target.date_loaded.value + ' ' + event.target.time_loaded.value,
                'inventory_id': event.target.inventory_id.value,
                'invoice_id': event.target.invoice_id.value,
                'liters': event.target.liters.value,
                'kilometers': event.target.kilometers.value,
                'total': event.target.total.value};
            console.log(data);
            axios({
                method:'PUT',
                url:apiUrl+'/finance/diesel',
            headers: {
                Authorization: authHeader()
            },
                data: data
            }).then(response => {
                props.onHide();
            })
            .catch(error => {
                alert(error);
            });
        }
        return (
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Editar Diesel
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Form onSubmit={handleButtonClick}>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="date_loaded">
                                    <Form.Label>Fecha de carga</Form.Label>
                                    <Form.Control type="date"
                                    defaultValue={datePart}/>
                                </Form.Group>
                                <Form.Group as={Col} controlId="time_loaded">
                                    <Form.Label>Hora de carga</Form.Label>
                                    <Form.Control
                                    type="time"
                                    defaultValue={timePart}/>
                                </Form.Group>
                                <Form.Group as={Col} controlId="inventory_id">
                                    <Form.Label>Unidad</Form.Label>
                                    <Form.Select defaultValue={props.data.inventory_id}>
                                        {units.map((unit) => (
                                        <option key={unit.id} value={unit.id} name={unit.name}>
                                            {unit.name}
                                        </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="liters">
                                    <Form.Label>Litros</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="0.00"
                                        pattern="[0-9.,]+"
                                        defaultValue={props.data.liters}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} controlId="kilometers">
                                    <Form.Label>KM al cargar</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="0.00"
                                        pattern="[0-9.,]+"
                                        defaultValue={props.data.kilometers}
                                    />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="total">
                                    <Form.Label>Total</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="$0.00"
                                        pattern="[0-9.,]+"
                                        defaultValue={props.data.total}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} controlId="invoice_id">
                                    <Form.Label>No. Factura Cobro</Form.Label>
                                    <Form.Control
                                        defaultValue={props.data.invoice_id}/>
                                </Form.Group>
                            </Row>
                            <Button type="submit" value="Submit">Guardar</Button>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_input = () => {this.props.setData(); this.setState({ modalShow: false });}
        return (
            <ButtonToolbar>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    <Icon.Edit size={14} />
                </Button>
                <DefaultModal show={this.state.modalShow} onHide={add_new_input} data={this.props.dieselInfo}/>
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
